import React from 'react';

import { Flex } from '@opendoor/bricks/core';

import { ParnLead } from '../../helpers/getAllParnLeadData';
import { CustomerDetailsCard } from '../../routes/ParnDashboard/CustomerDetailsCard';
import { ListingDetailsCard } from '../../routes/ParnDashboard/ListingDetailsCard';
import { ParnLeadDetailsLayout } from './ParnLeadDetailsLayout';
import { ParnStatusForm } from './ParnStatusForm';
import { ParnTimeline } from './ParnTimeline';
import { getStateForParn } from './parnUtils';

type ParnLeadDetailsPageProps = {
  agentLead: ParnLead;
  displayState: string;
  readableStreet: string;
  readableCity: string;
  isMobile: boolean;
};

export const ParnLeadDetailsPage: React.FC<ParnLeadDetailsPageProps> = ({
  agentLead,
  displayState,
  readableStreet,
  readableCity,
  isMobile,
}) => {
  const parnData = agentLead.parnData;

  const {
    parnId,
    listingId,
    listingPrice,
    contractPrice,
    soldPrice,
    grossCommission,
    agentNote,
    parnTimestampsMap,
    listingStateEntryTimes,
    parnState,
    listingState,
  } = parnData;

  return (
    <ParnLeadDetailsLayout isMobile={isMobile}>
      <Flex>
        <Flex flexDirection="column" gridGap={3} width="100%">
          <CustomerDetailsCard
            isMobile={isMobile}
            customerData={agentLead.customerData}
            addressStreet={readableStreet}
            addressCity={readableCity}
          />
          <ListingDetailsCard
            isMobile={isMobile}
            displayState={displayState}
            listingPrice={listingPrice}
            contractPrice={contractPrice}
            soldPrice={soldPrice}
            grossCommission={grossCommission}
          />
          <ParnStatusForm
            parnId={parnId ?? ''}
            listingId={listingId ?? ''}
            state={getStateForParn(parnState, listingState)}
            listingPrice={listingPrice}
            contractPrice={contractPrice}
            soldPrice={soldPrice}
            grossCommission={grossCommission}
            currentAgentNote={agentNote ?? ''}
            parnTimestampsMap={parnTimestampsMap ?? new Map()}
            listingsTimestampsMap={listingStateEntryTimes ?? new Map()}
          />
          <ParnTimeline
            parnTimestampsMap={parnTimestampsMap ?? new Map()}
            listingsTimestampsMap={listingStateEntryTimes ?? new Map()}
            parnState={parnState}
            isMobile={isMobile}
          />
        </Flex>
      </Flex>
    </ParnLeadDetailsLayout>
  );
};
